
import CustomerNameItem from '../components/selectCustomer/CustomerNameItem.vue'
import WithLabel from '@/components/DeptSelect/WithLabel.vue'

export default function () {
  const customerFormList = [
    {
      el: 'select',
      elRender: WithLabel,
      itemConfig: {
        label: '所属部门',
        prop: 'deptId',
        required: true,
      },
      elConfig: {
        events: {
          selectedNodesChange: (node) => {
            this.renderData.model.customerFormModel.deptId = node[0]?.id || ''
            this.renderData.model.customerFormModel.deptName = node[0]?.name || ''
          },
        },
        multiple: false,
        isAll: false,
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'customerType',
        value: '企业客户',
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '客户名称',
        prop: 'customerId',
        ref: 'customerIdRef',
      },
      elConfig: {
        disabled: false,
        options: {
          label: 'customerName',
          value: 'id',
        },
        remoteMethod: this.customerNameRemoteMethod,
        events: {
          change: this.customerNameChange,
          tipsClick: this.tipsClick,
        },
        placeholder: '请输入',
      },
      elRender: CustomerNameItem,
    },
  ]
  const customerFormModel = {}
  const customerRules = {
    customerId: [
      { required: true, message: '请选择客户', trigger: 'change' },
    ],
  }
  // text
  const customerTextList = [
    {
      el: 'text',
      itemConfig: {
        label: '客户ID',
        prop: 'customerId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
        width: 110,
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '统一社会信用代码',
        prop: 'creditCode',
      },
    },
  ]
  const customerTextModel = {}

  return {
    // form
    customerFormList,
    customerFormModel,
    customerRules,
    // text
    customerTextList,
    customerTextModel,
  }
}
